import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Page } from 'components/common';
import { Trans } from "react-i18next";
import LoadingMsg from 'components/common/LoadingMsg';
import { ApiClient } from 'services';

const Callback = () => {
  const history = useHistory();

  const client = ApiClient()

  const handleManualRedirect = () => {
    window.location.href = `/home`;
  };

  const [data, setData] = useState()
  const [isLoading, setLoading] = useState(true)
  const [isSuccess, setSuccess] = useState(false)
  const [error, setError] = useState(false)

  const urlParams = new URLSearchParams(window.location.search);
  const transactionId = urlParams.get('transaction_id');
  const tapId = urlParams.get('tap_id');

  const postValues = {
    transaction_id : transactionId,
    gateway_transaction_id: tapId
  }

  const noIDdata = {
    detail : "The Tap ID or the Transaction ID is missing"
  }

  useEffect(() => {
    if (!transactionId || !tapId) {
        setError(true);
        setLoading(false);
        setData(noIDdata);
        return;
    }

    const fetchData = async () => {
        try {
            const res = await client.post(`payment/callback`, postValues);
            const data = res.data;
            if (data?.detail === "The transaction has been settled already.") {
              setData(data);
            }
            setSuccess(true);
            setLoading(false);

            setTimeout(() => {
              handleManualRedirect()
              }, 15000)
        } catch (error) {
            console.error("Error fetching data:", error);
            setError(true);
            setLoading(false);
            setData(error.response.data);
        }
    };
    fetchData();
}, []);

  return (
    <Page title="" className="text-center mt-3">

      {isLoading? <LoadingMsg/>:
       <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-md-6 text-center">
            {isSuccess && !error ? 
            <div>
                <h1 className="display-4 font-weight-bold text-success"><Trans>Success!</Trans></h1>
                {data?.detail ? 
                  <div className="mb-4">
                    <h4><Trans><span>{data.detail}</span></Trans></h4>
                  </div>
                  :
                  <p className="lead"><Trans>Your payment has been done successfully.</Trans></p>
                }
                <h4 className="mb-4"><Trans>Welcome to Hesaab</Trans></h4>
                <p className="mb-3"><Trans>We hope we will achieve great things together.</Trans></p>
                <p className="mb-3"><Trans>You will be redirected to the Hesaab home page in <strong>15</strong> seconds.</Trans></p>
                <p className="mb-4"><Trans>Or you can click the button below to go directly.</Trans></p>
                <button onClick={handleManualRedirect} className="btn btn-primary btn-lg">
                <Trans>Go To Home</Trans>
                </button>
            </div>
            :
            <div>
                <h1 className="display-4 font-weight-bold text-danger"><Trans>Error!</Trans></h1>
                <p className="lead"><Trans>Your payment could not be completed.</Trans></p>
                {data?.detail && <div className="mb-4">
                    <h4><Trans><span>{data.detail}</span></Trans></h4>
                    <p><Trans>Please refer to the error and try again</Trans></p>
                </div>}
                <p className="mb-3"><Trans>You will be redirected to the home page in <strong>15</strong> seconds.</Trans></p>
                <p className="mb-4"><Trans>Or you can click the button below to go directly.</Trans></p>
                <button onClick={handleManualRedirect} className="btn btn-primary btn-lg">
                <Trans>Go To Home</Trans>
                </button>
            </div>
            }
          </div>
        </div>
      </div>}
    </Page>
  );
};

export default Callback;
